export enum OrderStatusEnum {
    NEW='new',
    ASSIGNED='assigned',
    READY_FOR_TAKE_OFF = 'ready_for_take_off',
    EN_ROUTE = 'en_route',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
    ERROR = 'error',
    IN_FLIGHT  = 'in_flight'
  }
  
export const OrderStatusNames: Record<OrderStatusEnum, string> = {
  [OrderStatusEnum.NEW]: 'New',
  [OrderStatusEnum.ASSIGNED]: 'Assigned',
  [OrderStatusEnum.READY_FOR_TAKE_OFF]: 'Ready for take off',
  [OrderStatusEnum.EN_ROUTE]: 'In flight',
  [OrderStatusEnum.COMPLETED]: 'Completed',
  [OrderStatusEnum.CANCELLED]: 'Cancelled',
  [OrderStatusEnum.ERROR]: 'Error',
  [OrderStatusEnum.IN_FLIGHT]: 'In flight',
};
  
export const OrderStatusColors: Record<OrderStatusEnum, string> = {
  [OrderStatusEnum.NEW]: 'success.main',
  [OrderStatusEnum.ASSIGNED]: 'ghost.main',
  [OrderStatusEnum.READY_FOR_TAKE_OFF]: 'warning.main',
  [OrderStatusEnum.EN_ROUTE]: 'info.main',
  [OrderStatusEnum.IN_FLIGHT]: 'info.main',
  [OrderStatusEnum.COMPLETED]: 'brand.main',
  [OrderStatusEnum.CANCELLED]: 'ghost.main',
  [OrderStatusEnum.ERROR]: 'error.main',
};
  